var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconIcFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 20,
    viewBox: "0 0 100 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "srrw63j0aa",
    d: "M0 0h14.363v15.123H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M22.243 3.987v3.866h4.317v10.92h4.97V7.853h4.317V3.987zM45.66 10.842c-.337.302-.843.453-1.517.453h-1.81V7.832h1.81c.674 0 1.18.151 1.517.454.337.303.505.728.505 1.278 0 .549-.168.975-.505 1.278m4.802 1.489c.477-.789.716-1.711.716-2.767 0-1.127-.274-2.112-.822-2.958-.547-.844-1.327-1.492-2.337-1.942-1.011-.451-2.198-.677-3.56-.677h-7.097v14.786h4.97v-3.718h1.348l2.507 3.718h5.307l-3.096-4.562c.898-.465 1.586-1.091 2.064-1.88"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.576 3.988)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4l9fl71ptb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#srrw63j0aa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.477 7.984c0 1.085-.193 1.873-.579 2.366-.386.493-.944.739-1.674.739s-1.289-.246-1.675-.74c-.386-.492-.579-1.28-.579-2.365V0H0v8.132c0 2.21.631 3.928 1.895 5.153 1.264 1.226 3.026 1.838 5.287 1.838 2.26 0 4.022-.612 5.286-1.838 1.263-1.225 1.895-2.942 1.895-5.153V0H9.477v7.984z",
    fill: "#FEFEFE",
    mask: "url(#4l9fl71ptb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.804 7.684c1.235 0 2.31.578 3.222 1.732l3.138-2.81a7.117 7.117 0 0 0-2.78-2.196c-1.123-.507-2.4-.76-3.832-.76-1.56 0-2.963.327-4.213.982s-2.23 1.57-2.938 2.746c-.709 1.176-1.064 2.51-1.064 4.002 0 1.493.355 2.827 1.064 4.003.709 1.176 1.689 2.09 2.938 2.746 1.25.654 2.654.982 4.213.982 1.431 0 2.709-.253 3.832-.76a7.117 7.117 0 0 0 2.78-2.197l-3.138-2.81c-.913 1.155-1.987 1.732-3.222 1.732-1.039 0-1.874-.334-2.506-1.003-.632-.669-.948-1.566-.948-2.693 0-1.126.316-2.024.948-2.693.632-.668 1.467-1.003 2.506-1.003M93.808 10.493l5.897-6.505h-5.412l-4.844 5.364V3.988h-4.887v14.785h4.887v-3.654l1.116-1.247 3.685 4.9H100zM0 18.895h7.66l2.581-7.188-3.83-10.672zM14.814 1.035l-3.83 10.671 2.58 7.189h7.661zM6.782 0l3.83 10.672L14.443 0z",
    fill: "#FEFEFE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcFooterLogo);
export default __webpack_public_path__ + "static/media/icon-ic-footer-logo.fb99886d35412d05aeb8f7a7ebf04402.svg";
export { ForwardRef as ReactComponent };